import store from '@/store'

function checkPermission(el, binding) {
  const name = binding.value[0]
  const permissionList = store.getters && store.getters.userPermissionItemLists

  let hasPermission = false
  // const routes = store.getters && store.getters.add_routes.slice(0, -1)
  // routes.forEach(item => {
  //   item.children.forEach(ele => {
  //     ele.meta.permissionItemList.forEach(e => {
  //       if (name === e.identify) {
  //         hasPermission = true
  //       }
  //     })
  //   })
  // })
  permissionList.forEach(e => {
    if (name === e.identify) {
      hasPermission = true
    }
  })
  if (!hasPermission) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  // update(el, binding) {
  //   checkPermission(el, binding)
  // },
}
